import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { NewUserComponent } from './components/new-user/new-user.component';
import { ManageUserComponent } from './components/manage-user/manage-user.component';
import { ConfirmationComponent } from './components/confirmation/confirmation.component';
import { CanDeactivateGuard } from './can-deactivate.guard';

const routes: Routes = [
  { path: 'new', component: NewUserComponent},
  { path: 'manage', component: ManageUserComponent, canDeactivate: [CanDeactivateGuard]},
  { path: 'confirmation', component: ConfirmationComponent},
  { path: '', redirectTo: '/new', pathMatch: 'full' },
  { path: '**', redirectTo: '/new', pathMatch: 'full'}
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
